
'use client'

import { useEffect } from 'react'
import Image from 'next/image'
import { SignIn, useAuth } from '@clerk/nextjs'
import { useRouter } from 'next/navigation'

export default function Home() {
  const router = useRouter()
  const { isLoaded, isSignedIn } = useAuth()

  useEffect(() => {
    if (!isLoaded || !isSignedIn) return
    router.push('/dashboard')
  }, [isLoaded, isSignedIn, router])

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <header className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950">
        <div className="mx-auto max-w-6xl px-4 py-6 sm:px-6 lg:px-8 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Image
              src="/weather-logic-dark.svg"
              alt="WXLOGIC"
              width={168}
              height={30}
              className="block dark:hidden"
              priority
            />
            <Image
              src="/weather-logic-light.svg"
              alt="WXLOGIC"
              width={168}
              height={30}
              className="hidden dark:block"
              priority
            />
          </div>
          <div>

          </div>
        </div>
      </header>

      {isLoaded && !isSignedIn && (
        <main className="px-4 py-10 sm:px-6 lg:px-8 min-h-[calc(100dvh-81px)] flex flex-col items-center justify-center">
          <div className="flex-1 flex items-center justify-center w-full">
            <SignIn forceRedirectUrl="/dashboard" />
          </div>

          <div className="w-full max-w-6xl mx-auto rounded-xl border border-gray-200 bg-white p-3 shadow dark:border-gray-700 dark:bg-gray-800">
            <p className="text-center text-base font-medium text-gray-900 dark:text-white">
              Login to the admin portal is restricted to station owners only.
            </p>
          </div>
        </main>
      )}

      {isLoaded && isSignedIn && (
        <div className="flex items-center justify-center min-h-[calc(100dvh-81px)] px-4">
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Loading...</h2>
            <p className="text-gray-600 dark:text-gray-300">Redirecting to dashboard...</p>
          </div>
        </div>
      )}

      {!isLoaded && (
        <div className="flex items-center justify-center min-h-[calc(100dvh-81px)] px-4">
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Loading...</h2>
            <p className="text-gray-600 dark:text-gray-300">Checking session...</p>
          </div>
        </div>
      )}
    </div>
  )
}

